import React from 'react'
import { Link } from 'react-router-dom'

import SecondaryButton from '@/main/components/shared/button/secondaryButton'
import { RoutesConstants } from '@/main/routes/routesConstants'
import { getTranslateByKey } from '@/main/services/utils'
import * as S from './styles'

interface ICookiesProps {
  isCookiesAccepted: boolean;
  handleClickAllowCookies: () => void;
}

function HomepageCookies({
  handleClickAllowCookies,
  isCookiesAccepted
}: ICookiesProps) {

  function handleClickToTop() {
    window.scrollTo({ top: 0 });
  }

  if (isCookiesAccepted) return <></>
  return (
    <>
      <S.AreaAbsolute>
        <S.Container>
          <S.Text>
            {getTranslateByKey('information.cookiesInfoAllow')}{' '}
            <Link to={RoutesConstants.homepageCookies} onClick={handleClickToTop}>
              {getTranslateByKey('information.learnMore')}
            </Link>
          </S.Text>
          <SecondaryButton
            id='id-allow-cookies'
            onClick={handleClickAllowCookies}
            sx={{
              backgroundColor: 'secondary.main',
              color: 'secondary.contrastText',
              border: '1px solid',
              borderColor: 'secondary.contrastText',
              textTransform: 'initial',
              fontSize: '0.7rem',
              padding: '8px 30px',
              '&:hover': { backgroundColor: '#949494' },
            }}
          >
            {getTranslateByKey('information.allowCookies')}
          </SecondaryButton>
        </S.Container>
      </S.AreaAbsolute>
      <S.BlockPage></S.BlockPage>
    </>
  )
}

export default HomepageCookies